// @ts-check
// Resumo dos modelos em Configurações > Canais (contrato 08 de leads e WhatsApp, seção 7): quantos aprovados, em
// análise e recusados em todos os números (pausados e desativados quando há), a última atualização da Meta e o link
// para a tela de modelos. Falha ao carregar aparece como falha, nunca como "nenhum modelo". Criar, sincronizar e
// excluir ficam só na tela de modelos.
import { html } from 'htm/preact';
import { useEffect, useState } from 'preact/hooks';
import { Link } from '../../../app/router.js';
import { listWhatsappTemplates } from '../../../data/integrations.js';
import { Icon } from '../../../ui/icon.js';
import { Skeleton } from '../../../ui/feedback.js';
import { formatDateTime } from '../../../lib/format.js';
import { WHATSAPP_TEMPLATES_PATH, summarizeTemplates, templateSummaryParts } from '../../../lib/whatsapp-templates.js';
import { t } from '../../../i18n/index.js';

export function WhatsappTemplatesSummary() {
  const [summary, setSummary] = useState(/** @type {ReturnType<typeof summarizeTemplates> | null} */ (null));
  const [loadFailed, setLoadFailed] = useState(false);
  const load = () => {
    setLoadFailed(false);
    setSummary(null);
    listWhatsappTemplates().then((templates) => setSummary(summarizeTemplates(templates))).catch(() => setLoadFailed(true));
  };
  useEffect(load, []);
  return html`<div class="channel-card template-summary">
    <div class="channel-card-header">
      <${Icon} name="IconClipboardText" size=${24} />
      <div class="channel-card-titles">
        <span class="channel-card-title">${t('whatsappTemplates.summary.title')}</span>
        <span class="channel-card-description">${t('whatsappTemplates.description')}</span>
      </div>
    </div>
    ${loadFailed
      ? html`<p class="template-summary-counts template-summary-failed" role="alert">
          <${Icon} name="IconAlertTriangle" size=${14} /><span>${t('whatsappTemplates.summary.loadFailed')}</span>
          <button type="button" class="integration-link template-summary-retry" onClick=${load}>${t('whatsappTemplates.actions.retry')}</button>
        </p>`
      : summary === null
        ? html`<${Skeleton} height=${20} radius=${6} />`
        : summary.total === 0
          ? html`<p class="template-summary-counts">${t('whatsappTemplates.summary.empty')}</p>`
          : html`<p class="template-summary-counts">
              ${templateSummaryParts(summary).map((part, index) => html`<span key=${part.key}>${index > 0 ? ', ' : ''}<span class="template-summary-part"
                data-highlight=${part.isHighlighted ? 'true' : undefined}>${t(`whatsappTemplates.summary.${part.key}`, { count: part.count })}</span></span>`)}
            </p>`}
    ${summary?.lastUpdatedAt ? html`<span class="integration-muted-small">${t('whatsappTemplates.summary.updatedAt', { date: formatDateTime(summary.lastUpdatedAt) })}</span>` : null}
    <div class="channel-card-actions">
      <${Link} href=${WHATSAPP_TEMPLATES_PATH} className="button template-summary-link" data-variant="secondary" data-size="small">
        <${Icon} name="IconClipboardText" size=${14} /><span>${t('whatsappTemplates.summary.manage')}</span>
      <//>
    </div>
  </div>`;
}
